<template>
  <div class="login">
    <div class="login-before-box" v-if="!isLogin">
      <span class="tip">*</span>
      <input type="text" v-if="IsPC" v-validate="'required|loginName'" name="loginName" placeholder="中国大陆手机号或邮箱登录/其他地区邮箱登录"
             v-model="login_name" @input="loginInput" @keyup.enter="doLogin"/>
      <input type="text" v-if="!IsPC" v-validate="'required|loginName'" name="loginName" placeholder="中国大陆手机号或邮箱登录/其他地区邮箱登录"
             v-model="login_name" @input="loginInput" @keyup.enter="doLogin"/>
      <div class="error-text">{{ errors.first('loginName') }}</div>
      <div class="error-text" v-show="noRegShow">{{ noRegText }}</div>
      <button class="login-btn" @click="doLogin">登录</button>
      <div class="tapRegister">没有账号，<a :href="registerUrl">立即注册</a></div>
    </div>
    <div class="login-after-box" v-if="isLogin && IsPC">
      <div class="hello-msg-box">
        <span>欢迎您，</span>
        <span>{{ name }}</span>
      </div>
      <a @click="doLogout">退出</a>
    </div>
  </div>
</template>

<script>
import { Cookies } from "smarket-pithy";
import bus from "../utils/eventBus";
import { setCookie, getCookie, removeCookie } from "../utils/public";
import VueCookies from "vue-cookies";

export default {
  name: "Login",
  data() {
    return {
      login_name: "",
      contentId: "",
      isLogin: false,
      errText: "",
      name: "",
      noRegShow: false,
      noRegText: "输入的手机或者邮箱未注册，请先注册",
      IsPC: false,
      registerUrl:
        "https://kee.smarket.com.cn/series/register/index.html#/register?type=系列会&backUrl=" +
        encodeURIComponent(window.location.href),
      increaseUrl:
        "https://kee.smarket.com.cn/series/register/index.html#/updateUser?type=系列会&backUrl=" +
        encodeURIComponent(window.location.href)
    };
  },
  props: ["screenWidth"],
  computed: {
    loginStatus() {
      return this.$store.state.loginStatus;
    }
  },
  watch: {
    loginStatus: function(val, oVal) {
      if (val == 1) {
        this.isLogin = true;
        this.name =
          this.$store.state.info.firstName + this.$store.state.info.lastName;
      } else {
        this.isLogin = false;
      }
    },
    screenWidth: function(val) {
      this.IsPC = val > 750;
    }
  },
  created() {
    Cookies.globalUserId.remove();
    let globaluserId = Cookies.globalUserId();
    this.contentId = globaluserId;
    setCookie("globalUserId", this.contentId, 7);
    this.$store.commit("setContentId", globaluserId);
    if (
      getCookie("username") == "undefined" ||
      getCookie("username") == "" ||
      !getCookie("username")
    ) {
    } else {
      this.getUserMsg();
    }
  },
  mounted() {
    this.IsPC = this.screenWidth > 750;
  },
  methods: {
    loginInput: function() {
      this.noRegShow = false;
    },
    doLogin: function() {
      this.$validator.validate("loginName").then(result => {
        if (result) {
          var _self = this;
          if (!window.$shielding.isAuth(_self.login_name)) {
            window.$shielding.show();
            return false
          }
          $.ajax({
            url: window.config.api.gateway.general + "/member/login",
            type: "post",
            dataType: "json",
            data: {
              tenantId: window.config.tenantId,
              schemaId: window.config.schemaId,
              memberFormId: window.config.formId,
              memberSchemaId: window.config.schemaId,
              unique: _self.login_name,
              token: "",
              password: "96E79218965EB72C92A549DD5A330112",
              checkCode: "",
              loginType: "",
              globalUserId: _self.contentId
            },
            success: function(e) {
              if (e.body.desc == "successful") {
                setCookie("globalUserId", e.body.content.session, 7);
                let formDataKey = window.config.formDataKey;
                let data = e.body;
                let formData = [];
                if (data["content"] && data["content"]["info"]) {
                  formDataKey.forEach(function(key) {
                    var obj = {
                      fieldName: key,
                      value: data["content"]["info"][key]
                    };
                    formData.push(obj);
                  });
                }
                smarket.cookie.smarketMember(
                  window.config.schemaId,
                  {
                    session: e.body.content.session,
                    memberId: e.body.content.memberModel.memberId,
                    formData: formData,
                    name: data["content"]["info"]["name"] || "",
                    registerTime:
                      data["content"]["memberModel"]["createTime"] || ""
                  },
                  { expires: 7 }
                );
                setCookie("sess", e.body.content.sess, 7);
                VueCookies.set("isKeeAutoLogin", _self.login_name);
                setCookie("username", e.body.content.memberModel.unique, 7);
                let requiredUpdate = false;
                const requiredField = window.config.requiredField;
                requiredField.forEach(item => {
                  if (!e.body.content.memberModel[item] && !requiredUpdate) {
                    requiredUpdate = true;
                  }
                });
                if (requiredUpdate) {
                  window.location.href = _self.increaseUrl;
                } else {
                  _self.login_name = "";
                  _self.$store.commit("setLoginStatus", 1);
                  _self.$store.commit(
                    "setUserInfo",
                    e.body.content.memberModel
                  );
                  bus.$emit("showToast", "登录成功");
                }
              } else {
                _self.noRegShow = true;
              }
            }
          });
        }
      });
    },
    doLogout: function() {
      removeCookie("sess");
      removeCookie("globalUserId");
      removeCookie("smarketMember_" + window.config.schemaId);
      removeCookie("username");
      VueCookies.set("isKeeAutoLogin", "");
      this.$store.commit("setLoginStatus", 0);
      this.$store.commit("setUserInfo", {});
      this.login_name = "";
    },
    getUserMsg: function() {
      //根据cookie获取用户信息
      var _self = this;
      $.ajax({
        //自动登录
        url: window.config.api.gateway.general + "/member/login",
        type: "post",
        dataType: "json",
        data: {
          tenantId: window.config.tenantId,
          schemaId: window.config.schemaId,
          memberFormId: window.config.formId,
          memberSchemaId: window.config.schemaId,
          unique: getCookie("username"),
          token: "",
          password: "96E79218965EB72C92A549DD5A330112",
          checkCode: "",
          loginType: "",
          globalUserId: _self.contentId
        },
        success: function(e) {
          if (e.body.desc == "successful") {
            setCookie("globalUserId", e.body.content.session, 7);
            smarket.cookie.smarketMember(
              window.config.schemaId,
              {
                session: e.body.content.session,
                memberId: e.body.content.memberModel.memberId
              },
              { expires: 7 }
            );
            setCookie("sess", e.body.content.sess, 7);
            setCookie("username", e.body.content.memberModel.unique, 7);
            if (e.body.content.status == "increase") {
              _self.$store.commit("setLoginStatus", 0);
            } else {
              _self.$store.commit("setLoginStatus", 1);
            }
            _self.$store.commit("setUserInfo", e.body.content.memberModel);
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@media (min-width: 750px) {
  .login {
    .login-before-box {
      padding: 25px 36px;
      text-align: center;
      border-top: 2px solid $commonRed;
      background: $loginbg;

      .tip {
        color: $commonRed;
        margin-right: 8px;
      }

      .error-text {
        text-align: left;
        color: $commonRed;
        margin-left: 30px;
        margin-top: 10px;
      }

      input {
        width: 460px;
        height: 38px;
        text-indent: 12px;
        border: 1px solid #dddddd;
        outline: none;
      }

      input::-ms-clear {
        display: none;
      }

      .login-btn {
        display: block;
        width: 160px;
        height: 36px;
        color: #fff;
        background-color: $commonRed;
        border: none;
        font-size: 15px;
        margin: 13px auto;
        cursor: pointer;
        outline: none;
      }

      .tapRegister {
        color: $color;
        font-size: 13px;

        a {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }

    .login-after-box {
      padding: 40px 0;
      text-align: center;
      border-top: 2px solid $commonRed;
      background: $loginbg;

      .hello-msg-box {
        font-size: 24px;
        font-weight: bold;
        color: $commonRed;
        padding-bottom: 15px;
      }

      a {
        font-size: 13px;
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
}

@media (max-width: 750px) {
  .login {
    width: 100%;

    .login-before-box {
      margin: 0 4%;
      margin-top: pxToRem(40);
      padding: pxToRem(68) pxToRem(0) pxToRem(38);
      text-align: center;
      border-top: 2px solid $commonRed;
      background: $loginbg;

      .tip {
        color: $commonRed;
        margin-right: pxToRem(8);
        font-size: pxToRem(28);
        vertical-align: middle;
      }

      .error-text {
        text-align: left;
        color: $commonRed;
        margin-left: pxToRem(80);
        margin-top: pxToRem(10);
        font-size: pxToRem(24);
      }

      input {
        width: 88%;
        font-size: pxToRem(24);
        padding: pxToRem(24) 0;
        height: pxToRem(66);
        text-indent: pxToRem(18);
        border: 1px solid #dddddd;
        vertical-align: middle;
        outline: none;
        color: #524f56;
        -webkit-appearance: none;
        border-radius: pxToRem(0);
        box-sizing: border-box;
      }

      .login-btn {
        display: block;
        width: pxToRem(290);
        height: pxToRem(70);
        color: #fff;
        background-color: $commonRed;
        border: none;
        font-size: pxToRem(24);
        border-radius: 3px;
        margin: pxToRem(35) auto pxToRem(20);
        cursor: pointer;
        outline: none;
        border-radius: pxToRem(0);
      }

      .tapRegister {
        color: $color;
        font-size: pxToRem(22);

        a {
          cursor: pointer;
          text-decoration: none;
          border-bottom: 1px solid #666666;
        }
      }
    }

    .login-after-box {
      margin: 0 4%;
      margin-top: pxToRem(40);
      padding: pxToRem(68) pxToRem(28) pxToRem(38);
      text-align: center;
      border-top: 2px solid $commonRed;
      background: $loginbg;

      .hello-msg-box {
        font-size: pxToRem(34);
        padding-bottom: pxToRem(30);
        font-weight: bold;
        color: $commonRed;
      }

      a {
        font-size: pxToRem(24);
        color: $color;
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
}
</style>
